export default "__VITE_ASSET__103acffe__"